import React from "react";
// import style from "./Skeleton.scss";

function SkeletonList(props) {
    const {filter: filters, count, hideLocation = false} = props;

    const SkeletonOutput = Array.apply(null, Array(count)).map((_, key) => (
        <div className={["tms-skeleton-wrap"].join(" ")} key={key}>
            <div className={["tms-skeleton-title"].join(" ")} />
            {hideLocation ? null :<div className={["tms-skeleton-location"].join(" ")} />}
            <div className={["tms-skeleton-property-wrap"].join(" ")}>
                {Array.apply(null, Array(filters)).map((_, subkey) => (
                    <div
                        key={subkey}
                        className={[
                            "tms-skeleton-property",
                            `tms-skeleton-property--${subkey}`,
                        ].join(" ")}
                    />
                ))}
            </div>
        </div>
    ));

    return SkeletonOutput;


}

export default SkeletonList;
